"use strict";

var _classCallCheck = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var Residues_1 = require("../common/Residues");
var react_pixi_1 = require("@inlet/react-pixi");
var MolecularStyles_1 = require("../common/MolecularStyles");
var CanvasAlignmentTiled = /*#__PURE__*/function (_react_1$default$Comp) {
  _inherits(CanvasAlignmentTiled, _react_1$default$Comp);
  function CanvasAlignmentTiled() {
    _classCallCheck(this, CanvasAlignmentTiled);
    return _possibleConstructorReturn(this, _getPrototypeOf(CanvasAlignmentTiled).apply(this, arguments));
  }
  _createClass(CanvasAlignmentTiled, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.alignment !== this.props.alignment || nextProps.colorScheme !== this.props.colorScheme || nextProps.positionsToStyle !== this.props.positionsToStyle || nextProps.sortBy !== this.props.sortBy;
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.alignment) {
        return null;
      }
      var _this$props = this.props,
        alignment = _this$props.alignment,
        alignmentType = _this$props.alignmentType,
        colorScheme = _this$props.colorScheme,
        positionsToStyle = _this$props.positionsToStyle,
        sortBy = _this$props.sortBy; // Generate multiple tiled images from the alignment
      var sequences = alignment.getSequences(sortBy);
      var fullWidth = alignment.getMaxSequenceLength();
      var fullHeight = sequences.length;
      var sizes = {
        fullWidth: fullWidth,
        fullHeight: fullHeight,
        targetTileWidth: Math.min(400, fullWidth),
        targetTileHeight: Math.min(400, fullHeight)
      };
      var tiledImages = this.initializeTiledImages(sizes);
      for (var tileYNumber = 0; tileYNumber < tiledImages.numYTiles; tileYNumber++) {
        for (var tileXNumber = 0; tileXNumber < tiledImages.numXTiles; tileXNumber++) {
          var tiledImage = this.generateCanvasForTile(tileXNumber, tileYNumber, sizes.targetTileWidth, sizes.targetTileHeight, tiledImages, sequences);
          tiledImages.tiles.push(tiledImage);
        }
      }
      //console.log("CANVAS rerender [" + sortBy.key + "]", sequences);
      return react_1.default.createElement(react_1.default.Fragment, null, tiledImages.tiles.map(function (tile) {
        return react_1.default.createElement(react_pixi_1.Sprite, {
          source: tile.image,
          x: tile.pixelX,
          y: tile.pixelY,
          key: "".concat(tile.tileX, "_\n                  ").concat(tile.tileY, "_\n                  ").concat(colorScheme.commonName, "_\n                  ").concat(positionsToStyle.key, "_\n                  ").concat(alignmentType.key, "_\n                  ").concat(sortBy.key, "_\n                  ").concat(alignment.getName())
        });
      }));
    }
  }, {
    key: "colorCanvasWithSequence",
    value: function colorCanvasWithSequence(tileImageData, tileCanvasContext, tileCanvas, sequences, offsets) {
      var imageDataIdx = 0;
      for (var seqIdx = 0; seqIdx < tileCanvas.height; seqIdx++) {
        var seq = sequences[seqIdx + offsets.seqY];
        for (var letterIdx = 0; letterIdx < tileCanvas.width; letterIdx++) {
          var letter = seq.sequence[letterIdx + offsets.letterX];
          var colorScheme = this.getCurrentMoleculeColors(letter, letterIdx, offsets);
          tileImageData.data[imageDataIdx] = colorScheme.rgb.red;
          tileImageData.data[imageDataIdx + 1] = colorScheme.rgb.green;
          tileImageData.data[imageDataIdx + 2] = colorScheme.rgb.blue;
          tileImageData.data[imageDataIdx + 3] = 255; //alpha between 0 (transparent) and 255 (opaque)
          imageDataIdx += 4;
        }
      }
      tileCanvasContext.putImageData(tileImageData, 0, 0);
    }
  }, {
    key: "generateCanvasForTile",
    value: function generateCanvasForTile(tileXNumber, tileYNumber, targetTileWidth, targetTileHeight, tiledImages, sequences) {
      var tileCanvas = document.createElement("canvas");
      tileCanvas.height = tileYNumber === tiledImages.numYTiles - 1 ? tiledImages.lastTileHeight : targetTileHeight;
      tileCanvas.width = tileXNumber === tiledImages.numXTiles - 1 ? tiledImages.lastTileWidth : targetTileWidth;
      var offsets = {
        seqY: tileYNumber * targetTileHeight,
        letterX: tileXNumber * targetTileWidth
      };
      var tileCanvasContext = tileCanvas.getContext("2d");
      tileCanvasContext === null || tileCanvasContext === void 0 ? void 0 : tileCanvasContext.fillRect(0, 0, tileCanvas.width, tileCanvas.height); //unclear why necessary
      var tileImageData = tileCanvasContext === null || tileCanvasContext === void 0 ? void 0 : tileCanvasContext.getImageData(0, 0, tileCanvas.width, tileCanvas.height);
      if (tileImageData && tileCanvasContext) {
        this.colorCanvasWithSequence(tileImageData, tileCanvasContext, tileCanvas, sequences, offsets);
      }
      return {
        tileX: tileXNumber,
        tileY: tileYNumber,
        pixelX: offsets.letterX,
        pixelY: offsets.seqY,
        width: tileCanvas.width,
        height: tileCanvas.height,
        image: tileCanvas
      };
    }
  }, {
    key: "getCurrentMoleculeColors",
    value: function getCurrentMoleculeColors(letter, letterIdx, offsets) {
      var _this$props2 = this.props,
        alignment = _this$props2.alignment,
        alignmentType = _this$props2.alignmentType,
        colorScheme = _this$props2.colorScheme;
      var consensusSequence = alignment.getConsensus().statistics;
      var querySequence = alignment.getQuerySequence().sequence;
      var moleculeClass = alignmentType === MolecularStyles_1.AlignmentTypes.AMINOACID ? Residues_1.AminoAcid : Residues_1.Nucleotide;
      var molecule = moleculeClass.UNKNOWN;
      if (this.props.positionsToStyle === MolecularStyles_1.PositionsToStyle.ALL) {
        molecule = moleculeClass.fromSingleLetterCode(letter);
      } else {
        var isConsensus = consensusSequence[letterIdx + offsets.letterX].letter === letter;
        var isQuery = querySequence[letterIdx + offsets.letterX] === letter;
        if (this.props.positionsToStyle === MolecularStyles_1.PositionsToStyle.CONSENSUS && isConsensus || this.props.positionsToStyle === MolecularStyles_1.PositionsToStyle.CONSENSUS_DIFF && !isConsensus || this.props.positionsToStyle === MolecularStyles_1.PositionsToStyle.QUERY && isQuery || this.props.positionsToStyle === MolecularStyles_1.PositionsToStyle.QUERY_DIFF && !isQuery) {
          molecule = moleculeClass.fromSingleLetterCode(letter);
        }
      }
      return molecule.colors[colorScheme.commonName];
    }
  }, {
    key: "initializeTiledImages",
    value: function initializeTiledImages(_ref) {
      var _ref$targetTileWidth = _ref.targetTileWidth,
        targetTileWidth = _ref$targetTileWidth === void 0 ? 0 : _ref$targetTileWidth,
        _ref$targetTileHeight = _ref.targetTileHeight,
        targetTileHeight = _ref$targetTileHeight === void 0 ? 0 : _ref$targetTileHeight,
        _ref$fullWidth = _ref.fullWidth,
        fullWidth = _ref$fullWidth === void 0 ? 0 : _ref$fullWidth,
        _ref$fullHeight = _ref.fullHeight,
        fullHeight = _ref$fullHeight === void 0 ? 0 : _ref$fullHeight;
      return {
        targetTileWidth: targetTileWidth,
        targetTileHeight: targetTileHeight,
        lastTileWidth: fullWidth % targetTileWidth !== 0 ? fullWidth % targetTileWidth : targetTileWidth,
        lastTileHeight: fullHeight % targetTileHeight !== 0 ? fullHeight % targetTileHeight : targetTileHeight,
        numXTiles: fullWidth % targetTileWidth !== 0 ? Math.floor(fullWidth / targetTileWidth) + 1 : Math.floor(fullWidth / targetTileWidth),
        numYTiles: fullHeight % targetTileHeight !== 0 ? Math.floor(fullHeight / targetTileHeight) + 1 : Math.floor(fullHeight / targetTileHeight),
        tiles: []
      };
    }
  }]);
  return CanvasAlignmentTiled;
}(react_1.default.Component);
exports.CanvasAlignmentTiled = CanvasAlignmentTiled;